//import { useWhyDidYouUpdate } from 'hooks';
import { getRouteByName } from 'app/routes';
import React, { useState, useEffect, useRef } from 'react';
import { generatePath, useHistory } from 'react-router-dom';
import { useRootStore } from 'store';
import { Dashboard } from './dashboard';
import { useTranslation } from 'react-i18next';
import './home-page.css';
import { Col, Row } from 'react-bootstrap';
import { WeekRep } from './weekchart';
import { Snowfall } from 'shared-pages';
import { Co2ImpactBanner } from './co2-impact-banner';

const HomePage = () => {
  const { appStore, authStore } = useRootStore();
  const history = useHistory();
  const [showScrollIndicator, setShowScrollIndicator] = useState(true);
  const chartRef = useRef(null);
  const { t, i18n } = useTranslation();

  const hasChartAccess =
    appStore.isPlatformOwner || appStore.isCollector || appStore.isCollectorDriver;
  //-------------------- Handlers -------------------------------------------
  //
  const handleUserClick = () => {
    console.log('handleUserClick', appStore.userLogin);
    history.push(generatePath(getRouteByName('User'), { id: authStore.userId }));
  };

  const handleScrollToChart = () => {
    if (chartRef.current) {
      chartRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  //-------------------- Effects --------------------------------------------
  // Hide the scroll indicator only when the chart section is visible.
  useEffect(() => {
    if (!hasChartAccess || !chartRef.current) {
      console.log('No chart access or no chartRef');
      // If the chart doesn't exist for this user, don't show the button at all.
      setShowScrollIndicator(false);
      return;
    }

    const target = chartRef.current;

    // When any meaningful chunk of the chart (25%+) is visible, hide the indicator.
    const observer = new IntersectionObserver(
      (entries) => {
        const entry = entries[0];
        setShowScrollIndicator(!entry.isIntersecting);
      },
      {
        root: null,
        rootMargin: '0px',
        threshold: 0.7, // tweak if you want it to hide sooner/later
      },
    );

    observer.observe(target);

    // Safety net: also update on resize (e.g., mobile address bar collapsing)
    const onResize = () => {
      // Force a quick check by toggling visibility based on current intersection
      // If chart is already in view, intersection callback will have handled it.
      // No-op here; IntersectionObserver reacts to layout changes.
    };
    window.addEventListener('resize', onResize);

    return () => {
      observer.disconnect();
      window.removeEventListener('resize', onResize);
    };
  }, [hasChartAccess]);

  //-------------------- Effects --------------------------------------------
  // Detect scroll position and show/hide the scroll indicator
  //Not Working Right now NEEDS REVIEW and FIX

  //
  //-------------------- Render ----------------------------------------------
  //
  //useWhyDidYouUpdate('[HomePage]', {});
  console.log('SCROLL INDICATOR', showScrollIndicator);
  return (
    <section className="home-page-section">
      <Snowfall />
      {/* Header + συνολική εξοικονόμηση CO₂ */}
      <div className="fk-header-row">
        <div className="fk-header-section">
          <div className="fk-header-content">
            <h1
              style={{ color: '#006EB6' }}
              className="d-flex align-items-center justify-content-center text-center not-found-container"
            >
              <img alt="" src={process.env.PUBLIC_URL + '/logo.png'} style={{ height: '4rem' }} />
              &nbsp;<span>Φωτοκύκλωση α.ε.</span>
            </h1>
            <p
              style={{ color: 'var(--fk-gray-800)', fontSize: 'var(--fk-font-size-lg)' }}
              className="mt-0 mb-1"
            >
              {i18n.language === 'gr'
                ? 'Καλώς Ορίσατε στην Εφαρμογή.'
                : 'Welcome to the Application.'}{' '}
            </p>
            {/* Χρήστης */}
            <Row style={{ color: 'var(--fk-gray-600)' }} className="mt-1 mb-1">
              <span>
                {i18n.language === 'gr' ? 'Συνδεθήκατε ως Χρήστης' : 'You are connected as User'}
                &nbsp;
              </span>
              <span
                className="btn btn-link p-0"
                style={{
                  color: 'var(--fk-green-primary)',
                  fontWeight: 'var(--fk-font-weight-semibold)',
                  textDecoration: 'none',
                }}
                onClick={handleUserClick}
                aria-label="Προβολή προφίλ χρήστη"
              >
                {appStore.userLogin.userFirstName + ' ' + appStore.userLogin.userLastName}
              </span>
              {appStore.isCollector ? (
                <span>&nbsp;({appStore.userLogin?.userView?.referenceName})</span>
              ) : appStore.isCollectorDriver ? (
                <span>
                  &nbsp;({appStore.userLogin?.userView?.referenceName}/
                  {appStore.userLogin?.userView?.referenceName2})
                </span>
              ) : (
                <></>
              )}
            </Row>
          </div>

          {/* Mobile App Links - Centered */}
          <div className="fk-header-links">
            <Row>
              <Col xs={12} className="text-center">
                <div className="fk-app-links justify-content-center">
                  {/*  Εφαρμογή Οδηγών */}
                  {(appStore.isPlatformOwner ||
                    appStore.isCollector ||
                    appStore.isCollectorDriver) && (
                    <a
                      href={`https://fotokiklosi-app-repo.s3.eu-west-1.amazonaws.com/fotokiklosi-drivers${
                        process.env.REACT_APP_DEMO === '1' ? '-qc' : ''
                      }.apk`}
                      className="fk-app-link"
                      download
                      aria-label="Κατεβάστε την εφαρμογή για οδηγούς"
                    >
                      📱{i18n.language === 'gr' ? 'Εφαρμογή Οδηγών' : 'Drivers Application'}
                    </a>
                  )}
                  {/*  Εφαρμογή Σημείων Συλλογής */}
                  {(appStore.isPlatformOwner || appStore.isCollector) && (
                    <a
                      href={process.env.REACT_APP_COLLECTIONPOINTS_APP}
                      className="fk-app-link"
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label="Ανοίξτε την εφαρμογή σημείων συλλογής"
                    >
                      🛒 {t('Εφαρμογή Σημείων Συλλογής')}
                    </a>
                  )}
                </div>
              </Col>
            </Row>
          </div>
        </div>
        <Co2ImpactBanner />
      </div>

      {/* Dashboard Section - Animated */}
      {!(appStore.isCollectionPoint || appStore.isContributor) && (
        <div className="dashboard-container">
          <Dashboard />
        </div>
      )}

      {/* Charts Section - Role-based visibility - Animated */}
      {(appStore.isPlatformOwner || appStore.isCollector || appStore.isCollectorDriver) && (
        <div className="fk-chart-container chart-section" ref={chartRef}>
          <WeekRep />
        </div>
      )}

      {/* Scroll Indicator Button */}
      {hasChartAccess && (
        <div
          className={`scroll-to-chart-container scroll-to-chart-container--right-center ${
            showScrollIndicator ? 'visible' : ''
          }`}
        >
          <button
            onClick={handleScrollToChart}
            className="scroll-to-chart-btn"
            aria-label="Δείτε τα γραφήματα"
            title="Κάντε scroll για γραφήματα"
            type="button"
          >
            <span className="scroll-to-chart-arrow" aria-hidden="true"></span>
          </button>
        </div>
      )}

      {/* Debug Info */}
    </section>
  );
};

export default HomePage;
HomePage.whyDidYouRender = true;
